var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.795,
    height: 18.671,
    viewBox: "0 0 24.795 18.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#6f2fd3;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.b{fill:#6f2fd3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-306.88 -663.948)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.438,8.5A1.948,1.948,0,0,0,8.5,10.438V24.187a.96.96,0,0,0,1.538.766l1.809-1.366a2.943,2.943,0,0,1,1.741-.58h15.76a1.948,1.948,0,0,0,1.948-1.948V10.438A1.948,1.948,0,0,0,29.357,8.5Z",
    transform: "translate(299.38 656.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M232.576,105.94a1.036,1.036,0,1,1-1.036,1.036,1.036,1.036,0,0,1,1.036-1.036",
    transform: "translate(90.784 565.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M170.5,105.94a1.036,1.036,0,1,1-1.036,1.036,1.036,1.036,0,0,1,1.036-1.036",
    transform: "translate(148.843 565.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.5,105.94a1.036,1.036,0,1,1-1.036,1.036,1.036,1.036,0,0,1,1.036-1.036",
    transform: "translate(208.699 565.318)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageActiveIcon);
export default __webpack_public_path__ + "static/media/messageActiveIcon.66f6f4ef3c08e077275e3c98a6eb23dd.svg";
export { ForwardRef as ReactComponent };